module.exports = __webpack_public_path__ + "img/tree-07-f-leaves.e1b9efc2.png";